/**
 * 외부 통신 로그 (/adm/vendor-logs) — 업체와 주고받은 요청·응답 기록(방향·업체·용도·회원·거래ID·결과·기간)
 * ($j.Pages.Admin.VendorLog / body data-page-name="VendorLog")
 *
 * 분류 조각(방향·업체·용도)·이름표는 컨트롤러가 #page-data 로 넘긴다.
 */
export default class VendorLog {
    initialize() {
        const PAGE = JSON.parse(document.getElementById('page-data').textContent);
    let $table = null;

    $(function () {
        $('#btnReload').on('click', reloadTable);
        $('#btnResetFilter').on('click', resetFilter);
        $('#log-table').on('click', 'a.cell-detail[data-n]', function (e) {
            e.preventDefault();
            showDetail(Number(this.dataset.n));
        });
        $('#f_date_from, #f_date_to').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [],
        });
        loadTable();
    });

    function loadTable() {
        const columns = [
            {data: 'num', title: '#', width: '70px'},
            {data: 'ca', title: '분류', width: '200px',
                render: v => caLabel(v)},
            // 회원 표기는 관리자 공용 규약 — `이름#번호` + 회원 팝오버
            {data: null, title: '회원', width: '140px',
                render: (d, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name)},
            {data: 'txid', title: 'txid', width: '280px',
                render: v => v ? `<span class="vl-break">${escapeHtml(v)}</span>` : '-'},
            {data: 'result', title: 'result', width: '70px',
                render: v => {
                    if (!v) return '-';
                    if (v === 'ERR' || v === '0') return `<span class="text-danger">${v}</span>`;
                    if (v === 'A000' || v === '200') return `<span class="text-success">${v}</span>`;
                    return v;
                }},
            {data: 'request_time', title: '요청', width: '160px',
                render: v => v ? renderDt(v) : '-'},
            {data: 'response_time', title: '응답', width: '160px',
                render: v => v ? renderDt(v) : '<span class="text-muted">-</span>'},
            {data: 'request_preview', title: 'request', width: '160px',
                render: (v, _, row) => v
                    ? `<a href="#" class="cell-detail" data-n="${row.num}">${escapeHtml(v.substr(0, 18))}${v.length > 18 ? '…' : ''}</a>`
                    : '-'},
            {data: 'result_preview', title: 'result', width: '160px',
                render: (v, _, row) => v
                    ? `<a href="#" class="cell-detail" data-n="${row.num}">${escapeHtml(v.substr(0, 18))}${v.length > 18 ? '…' : ''}</a>`
                    : '-'}
        ];

        if ($table) { $table.destroy(); $('#log-table').empty(); }

        $table = new DataTable('#log-table', {
            autoWidth: false,
            columns,
            headerCallback: thead => $(thead).find('th').css('text-align', 'center'),
            ajax: {
                url: '/adm/ajax/vendor-logs/list',
                type: 'post',
                data: d => Object.assign(d, {
                    dir: $('#f_dir').val(),
                    vendor: $('#f_vendor').val(),
                    ca: $('#f_ca').val(),
                    mb_no: $('#f_mb_no').val(),
                    txid: $('#f_txid').val(),
                    result: $('#f_result').val(),
                    date_from: $('#f_date_from').val(),
                    date_to: $('#f_date_to').val(),
                })
            },
            language: {
                emptyTable: '데이터가 없습니다.',
                info: '_TOTAL_ 건',
                loadingRecords: '로딩 중...',
                zeroRecords: '일치하는 결과가 없습니다.',
                paginate: {previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>"}
            },
            processing: true,
            serverSide: true,
            ordering: false,
            pageLength: 25,
            lengthChange: false,
            searching: false
        });
    }

    function reloadTable() {
        $table && $table.ajax.reload();
    }

    /** 분류 목록 — [{ca, dir:'in'|'out', vendor, purpose}] (VendorLogController::parseCa) */
    const CA_PARTS = PAGE.caParts;

    /** 한글명 선언 — VendorLogController::VENDOR_LABELS · PURPOSE_LABELS */
    const LABELS = PAGE.labels;

    /** 목록·상세의 분류 표시 — [수신] 업체 · 용도 (한글명이 없으면 영문 그대로). 영문 원이름은 마우스를 올리면 보인다 */
    function caLabel(ca) {
        if (!ca) return '-';
        const inb  = isInbound(ca);
        const rest = inb ? ca.substr(3) : ca;
        const [vendor, ...p] = rest.split('_');
        const purpose = LABELS.purpose[rest] || p.join('_');
        const text = (LABELS.vendor[vendor] || vendor) + (purpose ? ' · ' + purpose : '');
        return (inb ? '<span class="badge bg-info text-dark me-1">수신</span>' : '')
            + `<span title="${escapeHtml(ca)}">${escapeHtml(text)}</span>`;
    }

    /** 버튼 묶음 — 누른 것만 채워 칠하고 hidden 값을 바꾼다 */
    function setBtn(groupSel, key, hiddenSel, val) {
        $(hiddenSel).val(val);
        $(groupSel + ' button').each(function () {
            const on = String($(this).data(key)) === val;
            $(this).toggleClass('btn-primary', on).toggleClass('btn-outline-primary', !on);
        });
    }
    function setDir(dir)       { setBtn('#dir-btns', 'dir', '#f_dir', dir); }

    /** 용도 드롭다운 — 고른 방향·업체에 맞는 분류만. 고르던 값이 목록에서 빠지면 전체로 */
    function fillPurpose() {
        const dir = $('#f_dir').val(), vendor = $('#f_vendor').val(), cur = $('#f_ca').val();
        const rows = CA_PARTS.filter(p => (!dir || p.dir === dir) && (!vendor || p.vendor === vendor));
        const $sel = $('#f_ca').empty().append('<option value="">전체</option>');
        rows.forEach(p => {
            const label = (vendor ? '' : p.vendorLabel + ' · ') + p.purposeLabel + (!dir && p.dir === 'in' ? ' (수신)' : '');
            $sel.append($('<option>').val(p.ca).text(label));
        });
        $sel.val(rows.some(p => p.ca === cur) ? cur : '');
    }

    $(document).on('click', '#dir-btns button', function () {
        setDir(String($(this).data('dir')));
        fillPurpose();
        reloadTable();
    });
    $(document).on('change', '#f_vendor', function () {
        fillPurpose();
        reloadTable();
    });
    $(document).on('change', '#f_ca', reloadTable);
    $(fillPurpose);

    function resetFilter() {
        setDir('');
        $('#f_vendor,#f_ca,#f_mb_no,#f_txid,#f_result').val('');
        fillPurpose();
        // 기본 기간 = 서버가 그려 둔 value 속성(7일 전 ~ 오늘)
        $('#f_date_from').val($('#f_date_from').prop('defaultValue'));
        $('#f_date_to').val($('#f_date_to').prop('defaultValue'));
        reloadTable();
    }

    /** 수신 기록인가 — VendorInbound 미들웨어가 ca 를 'in_' 로 남긴다 */
    function isInbound(ca) { return typeof ca === 'string' && ca.indexOf('in_') === 0; }

    function showDetail(num) {
        $.post('/adm/ajax/vendor-logs/detail', {num}, function (res) {
            if (!res.result) { alert('조회 실패'); return; }
            const r = res.row;
            const inb = isInbound(r.ca);   // 수신이면 request=업체가 보낸 것, result=우리가 돌려준 것
            const html = `
                <table class="table table-sm vl-det-table">
                    <tbody>
                        <tr><th width="120">#</th><td>${r.num}</td></tr>
                        <tr><th>분류 (ca)</th><td>${caLabel(r.ca)} <span class="text-muted">(${escapeHtml(r.ca || '-')})</span></td></tr>
                        <tr><th>회원번호</th><td>${r.mb_no || '-'}</td></tr>
                        <tr><th>txid</th><td>${escapeHtml(r.txid || '-')}</td></tr>
                        <tr><th>result</th><td>${r.result || '-'}</td></tr>
                        <tr><th>요청 시각</th><td>${r.request_time || '-'}</td></tr>
                        <tr><th>응답 시각</th><td>${r.response_time || '-'}</td></tr>
                    </tbody>
                </table>
                <h6 class="mt-3">request_body ${inb ? '— 업체가 보낸 요청' : '— 우리가 보낸 요청'}</h6>
                <pre class="bg-light p-2 vl-pre">${escapeHtml(r.request_body || '')}</pre>
                <h6 class="mt-3">result_body ${inb ? '— 우리가 돌려준 응답' : '— 업체 응답'}</h6>
                <pre class="bg-light p-2 vl-pre">${escapeHtml(r.result_body || '')}</pre>
            `;
            $j.Ui.JBModal.html('vendor-log-detail', html, `통신로그 #${r.num} (${r.ca || '-'})`, {width: '780px'});
        }, 'json');
    }

    function renderDt(v) {
        const [d, t] = String(v).split(' ');
        return `<span class="vl-dt">${d || ''} <span class="vl-blue">${t || ''}</span></span>`;
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
    }
}
